import * as cnt from './constants';
import * as cnts from '../../master-template-list/__storeFiles__/constants';

export function createNGoToDraft(payload) {
  return { type: cnt.CREATE_EDITED_DRAFT, payload };
}

export function saveSupplierInfoChanges(payload) {
  return { type: cnt.SAVE_EDITS, payload };
}

export function openEditDialog(payload) {
  return { type: cnt.INITIATE_EDIT_WITH_TYPE, payload };
}

export function cancelEdit() {
  return { type: cnt.CANCEL_EDIT };
}

export function clickFinalise() {
  return { type: cnt.CLICK_FINALISE };
}

export function finalise() {
  return { type: cnt.FINALISE };
}

export function closeFinaliseDialog() {
  return { type: cnt.CLOSE_FINALISE_DIALOG };
}

export function discardDraft() {
  return { type: cnt.DISCARD_DRAFT };
}

export function toggleAssoicatedTemplates() {
  return { type: cnt.TOGGLE_ASSOCIATED_TEMPLATES };
}

/* for editDialog */
export function onTextFieldChange(payload) {
  return { type: cnt.TEXT_FIELD_CHANGE, payload };
}

// for billing only
// in order to reuse the same edit component, need to supply the same functions
export function attachInsFile(payload) {
  return { type: cnt.ATTACH_INS_FILE, payload };
}

export function removeInsFile() {
  return { type: cnt.REMOVE_INSURANCE_FILE };
}

export function saveBillingInfoChanges() {
  return { type: cnt.SAVE_EDITS, payload: { updateType: 'SAVE_BILLING_INFO_ADD_EDIT' } };
}

/*
  for associate master template wizard
  One master - to - Many templates
*/

export function selectUnselectDraft(payload) {
  return { type: cnt.apply.SELECT_UNSELECT_TEMPLATE, payload };
}

export function applyToTemplates() {
  return { type: cnt.apply.APPLY_TO_TEMPLATES };
}

export function clickOk() {
  return { type: cnt.apply.CLICK_OK_SUCCESS };
}

export function checkSameAsCorporate(payload) {
  return { type: cnt.apply.CHECK_SAME_AS, payload };
}

export function checkHonor(honorPreloadContent) {
  return { type: cnt.apply.CHECK_HONOR_PRELOAD, payload: honorPreloadContent };
}

/*
  for pick master template wizard
  One template - to - Many master
  for policyNotes it's one-to-one
  for product spacific it's one-to-many
*/
export function selectMaster(payload) {
  return { type: cnt.apply.SELECT_MASTER, payload };
}



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/__storeFiles__/actions.js